module.exports = __webpack_public_path__ + "static/save-d5cb01e321d0854721e8bc2f532d9ba3.svg";